module.exports = __webpack_public_path__ + "static/media/gerb-4.73bef16d.png";